import React from 'react';

function SongDetails({ title, description }) {
  return (
    <div className="song-details">
      <h1 className="song-title">{title}</h1>
      <p className="song-description">{description}</p>
    </div>
  );
}

export default SongDetails;